// src/api/apiClient.js
import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  headers: {
    "X-API-Key": process.env.REACT_APP_API_KEY,
  },
});

// Optional: Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("Unauthorized - Invalid API Key");
    }
    return Promise.reject(error);
  }
);

export default apiClient;
